var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { isFunction } from './utils';
var StoreLite = /** @class */ (function () {
    function StoreLite(initialState) {
        this.store$ = new BehaviorSubject(__assign({}, initialState, { loading: false, error: null }));
        this.vm$ = this.store$.asObservable();
    }
    StoreLite.prototype.update = function (newState) {
        if (isFunction(newState)) {
            this.store$.next(newState(this.store$.getValue()));
        }
        else {
            this.store$.next(__assign({}, this.store$.getValue(), newState));
        }
    };
    StoreLite.prototype.select = function (project) {
        return this.vm$.pipe(map(project), distinctUntilChanged());
    };
    StoreLite.prototype.selectSnapshot = function (project) {
        return project(this.store$.getValue());
    };
    StoreLite.prototype.selectLoading = function () {
        return this.select(function (state) { return state.loading; });
    };
    StoreLite.prototype.getLoading = function () {
        return this.store$.getValue().loading;
    };
    StoreLite.prototype.getError = function () {
        return this.store$.getValue().error;
    };
    StoreLite.prototype.selectError = function () {
        return this.select(function (state) { return state.error; });
    };
    StoreLite.prototype.updateLoading = function (loading) {
        this.update({ loading: loading });
    };
    StoreLite.prototype.updateError = function (error) {
        this.update({ error: error });
    };
    return StoreLite;
}());
export { StoreLite };
//# sourceMappingURL=store-lite.js.map